import React, { useState, useEffect } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";

import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "config";

const AddCompatibleProduct = ({
	categoryBcId,
	baseProductId,
	compatibilityId,
	compatibleProductsBCIds,
	onAddedCompatibility,
	compatibleProductsBCIdsPositions,
}) => {
	const [compatibleProducts, setCompatibleProducts] = useState([]);

	const submit = async (values, { resetForm }) => {
		const update = {
			compatibleProductsBCIds: [values?.compatibleProduct?.bcId],
			compatibleProductsBCIdsPositions: [
				...compatibleProductsBCIdsPositions,
				{
					id: values?.compatibleProduct?.bcId,
					position: compatibleProductsBCIds.length,
				},
			],
		};
		try {
			const response = await axios.put(
				`${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/base-products/${baseProductId}/compatibilities/${compatibilityId}`,
				update
			);
			if (response.status === 200) {
				if (onAddedCompatibility) {
					onAddedCompatibility();
				}
			}
		} catch (error) {
			console.log("error: ", error);
		}
	};

	const ProductCompatibilitySchema = Yup.object().shape({
		compatibleProduct: Yup.object().shape({
			bcId: Yup.string().min(1, "Too Short!").required("Required"),
		}),
	});

	const formik = useFormik({
		initialValues: {
			compatibleProduct: { bcId: "" },
		},
		validateOnMount: true,
		validationSchema: ProductCompatibilitySchema,
		onSubmit: submit,
	});

	const { compatibleProduct } = formik.values;

	const getCompatibleProducts = async () => {
		if (!categoryBcId) {
			console.error("Missing categoryBcId");
			return;
		}
		try {
			const response = await axios.get(
				`${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/bc/products?categories=${categoryBcId}`
			);
			if (response.status === 200) {
				let compatibleProducts = response.data.products;
				compatibleProducts = compatibleProducts.filter(
					(compatibleProduct) => {
						const alreadyAdded = compatibleProductsBCIds.find(
							(compatibleProductsBCId) =>
								compatibleProduct.id === compatibleProductsBCId
						);
						if (alreadyAdded) {
							return false;
						} else {
							return true;
						}
					}
				);
				setCompatibleProducts(compatibleProducts);
				if (compatibleProducts[0]) {
					formik.setFieldValue("compatibleProduct", {
						bcId: compatibleProducts[0].id,
					});
				}
			}
		} catch (error) {
			console.log("error: ", error);
		}
	};

	useEffect(() => {
		getCompatibleProducts(); // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [compatibleProductsBCIds.length]);

	return (
		<div style={{ padding: "10px 0px" }}>
			<Form onSubmit={formik.handleSubmit}>
				<Row
					style={{
						alignItems: "baseline",
					}}>
					<Col xs={{ span: 6 }}>
						<Form.Group controlId="type" size="lg">
							<Form.Control
								as="select"
								name="type"
								value={compatibleProduct.bcId}
								onChange={(e) => {
									formik.setFieldValue("compatibleProduct", {
										bcId: e.target.value,
									});
								}}>
								{compatibleProducts.map((compatibleProduct) => (
									<option
										value={compatibleProduct.id}
										key={compatibleProduct.id}>
										SKU: {compatibleProduct.sku}{" "}
										{compatibleProduct.name}
									</option>
								))}
							</Form.Control>
						</Form.Group>
					</Col>
					<Col xs={{ span: 6 }}>
						<Button type="submit">Add</Button>
					</Col>
				</Row>
			</Form>
		</div>
	);
};

export default AddCompatibleProduct;
